import type { BrandVariants } from '@fluentui/react-components';

/**
 * CareDocs brand ramp. Generated to match the CareDocs primary blue.
 * Replace these values to re-skin the app — no component change required.
 *
 * Source palette: deep azure with cooler steps, suitable for clinical UI dark default.
 */
export const caredocsBrand: BrandVariants = {
  10: '#020306',
  20: '#0a1422',
  30: '#0f2240',
  40: '#11305a',
  50: '#113e75',
  60: '#0e4d92',
  70: '#055caa',
  80: '#1a6bbf',
  90: '#327ad0',
  100: '#4d89dc',
  110: '#6a98e6',
  120: '#86a7ee',
  130: '#a0b6f4',
  140: '#bac6f8',
  150: '#d2d7fb',
  160: '#e8e9fd',
};
